import cx from 'classnames';
import { forwardRef, KeyboardEvent, ChangeEvent } from 'react';

interface InviteTextareaProps {
  value: string;
  onChange: (e: ChangeEvent<HTMLTextAreaElement>) => void;
  onKeyDown: (e: KeyboardEvent<HTMLTextAreaElement>) => void;
  onPaste: (e: React.ClipboardEvent<HTMLTextAreaElement>) => void;
  placeholder: string;
  hasInvitees: boolean;
  className?: string;
  rows: number;
}

const InviteTextarea = forwardRef<HTMLTextAreaElement, InviteTextareaProps>(
  ({ value, onChange, onKeyDown, onPaste, placeholder, hasInvitees, className, rows }, ref) => (
    <textarea
      ref={ref}
      value={value}
      onChange={onChange}
      onKeyDown={onKeyDown}
      onPaste={onPaste}
      placeholder={placeholder}
      className={cx(
        'flex-1 min-w-[200px] resize-none border-none outline-none focus:ring-0 focus:ring-transparent bg-transparent text-size-sm placeholder:text-gray-70 placeholder:font-light',
        { '!p-0': !hasInvitees },
        className
      )}
      rows={rows}
    />
  )
);

InviteTextarea.displayName = 'InviteTextarea';

export default InviteTextarea;
